import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const CompanyHeader = ({ company, onFollowCompany, isFollowing }) => {
  return (
    <div className="bg-card border-b border-border">
      <div className="relative h-64 sm:h-80 lg:h-96 overflow-hidden">
        <Image
          src={company?.coverImage}
          alt={company?.coverImageAlt}
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-background/90 to-transparent" />
      </div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="relative -mt-20 sm:-mt-24 lg:-mt-32">
          <div className="flex flex-col sm:flex-row items-start sm:items-end gap-4 sm:gap-6">
            <div className="w-32 h-32 sm:w-40 sm:h-40 lg:w-48 lg:h-48 bg-card border-4 border-background rounded-2xl overflow-hidden shadow-modal flex-shrink-0">
              <Image
                src={company?.logo}
                alt={company?.logoAlt}
                className="w-full h-full object-contain p-4"
              />
            </div>

            <div className="flex-1 pb-6">
              <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-4">
                <div className="flex-1">
                  <h1 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-foreground mb-2">
                    {company?.name}
                  </h1>
                  <p className="text-base sm:text-lg text-muted-foreground mb-3">
                    {company?.tagline}
                  </p>
                  <div className="flex flex-wrap items-center gap-3 sm:gap-4 text-sm text-muted-foreground">
                    <div className="flex items-center gap-2">
                      <Icon name="Building2" size={18} />
                      <span>{company?.industry}</span>
                    </div>
                    <div className="flex items-center gap-2">
                      <Icon name="Users" size={18} />
                      <span>{company?.employeeCount}</span>
                    </div>
                    <div className="flex items-center gap-2">
                      <Icon name="MapPin" size={18} />
                      <span>{company?.location}</span>
                    </div>
                    <div className="flex items-center gap-2">
                      <Icon name="Calendar" size={18} />
                      <span>Founded {company?.foundedYear}</span>
                    </div>
                  </div>
                </div>

                <div className="flex items-center gap-3">
                  <Button
                    variant={isFollowing ? "outline" : "default"}
                    onClick={onFollowCompany}
                    iconName={isFollowing ? "Check" : "Plus"}
                    iconPosition="left"
                  >
                    {isFollowing ? "Following" : "Follow Company"}
                  </Button>
                  <Button variant="outline" iconName="Share2" size="icon">
                    <span className="sr-only">Share</span>
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CompanyHeader;